import { TimeService_timeServiceGetGetTime } from '@festina/datamart-general-types/datamart-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchDatamartTimeNoSuspense =
  TimeService_timeServiceGetGetTime.useQuery
